var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionsRename(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M12.938 14.625a.56.56 0 0 1-.563.563H11.25A2.81 2.81 0 0 1 9 14.062a2.81 2.81 0 0 1-2.25 1.126H5.625a.563.563 0 0 1 0-1.126H6.75a1.687 1.687 0 0 0 1.688-1.687V9.563H7.312a.563.563 0 1 1 0-1.126h1.125V5.626A1.687 1.687 0 0 0 6.75 3.938H5.625a.563.563 0 1 1 0-1.126H6.75A2.81 2.81 0 0 1 9 3.939a2.81 2.81 0 0 1 2.25-1.126h1.125a.562.562 0 1 1 0 1.126H11.25a1.687 1.687 0 0 0-1.687 1.687v2.813h1.124a.562.562 0 1 1 0 1.124H9.564v2.813a1.687 1.687 0 0 0 1.687 1.688h1.125a.56.56 0 0 1 .563.562"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsRename);
export default __webpack_public_path__ + "static/media/actions-rename.e6dbc10b54ecd016dfc9408802c39d6f.svg";
export { ForwardRef as ReactComponent };